import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Dashboard/layout';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import "./TestimonialsPage.css";
import { ADDBTN, Headings, SerchInput, UserSelect } from '../RegisteredUsersList/ViewRegList';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [filteredTestimonials, setFilteredTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [testimonialsPerPage] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/admin/testimonials`);
        if (response.data && response.data.testimonials && response.data.testimonials.length > 0) {
          setTestimonials(response.data.testimonials);
          setFilteredTestimonials(response.data.testimonials);
        } else {
          //Swal.fire('No Data Available', 'There are no testimonials available at the moment.', 'info');
        }
      } catch (error) {
        console.error('Failed to fetch testimonials:', error);
        Swal.fire('Error', 'Failed to load testimonials. Please try again later.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  useEffect(() => {
    let filtered = testimonials;

    if (selectedStatus) {
      filtered = filtered.filter((testimonial) => testimonial.status === parseInt(selectedStatus)); 
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (testimonial) =>
          testimonial.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredTestimonials(filtered);
    setCurrentPage(1);
  }, [selectedStatus, searchQuery, testimonials]);

  const handleDeleteTestimonial = (testimonialId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this testimonial!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}api/admin/testimonials/${testimonialId}`)
          .then(() => {
            setTestimonials(testimonials.filter((testimonial) => testimonial._id !== testimonialId));
            setFilteredTestimonials(filteredTestimonials.filter((testimonial) => testimonial._id !== testimonialId));
            Swal.fire('Deleted!', 'The testimonial has been deleted.', 'success');
          })
          .catch((error) => {
            console.error('Error deleting testimonial:', error);
            Swal.fire('Error', 'There was an issue deleting this testimonial.', 'error');
          });
      }
    });
  };

  const handleEditTestimonial = (testimonialId) => {
    navigate(`/edit-testimonial/${testimonialId}`);
  };

  const handleAddTestimonialClick = () => {
    navigate('/add-testimonial');
  };



  const indexOfLastTestimonial = (currentPage - 1) * testimonialsPerPage;
 // const indexOfFirstTestimonial = indexOfLastTestimonial - testimonialsPerPage;
  const currentTestimonials = filteredTestimonials.slice(indexOfLastTestimonial, indexOfLastTestimonial+testimonialsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredTestimonials.length / testimonialsPerPage);
 

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ];

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Testimonials" hedtext=" List" />

        <div className="TopSelctDiv">
          <div className="LeftSlct">
         <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" />
          </div>
          <div className="RytSrch">
            <SerchInput
              searchvalue={searchQuery}
              searchonchange={(e) => setSearchQuery(e.target.value)}
              srchid="searchQuery"
              srchplcehldr="Search by name"
            />
            <ADDBTN adtext="Add Testimonial" adonclick={handleAddTestimonialClick} />
          </div>
        </div>

        <div className="TableSec">
          {loading ? (
            <p className="Loadingpara">Loading...</p>
          ) : (
            <>
              <div className="UserTableDiv">
                <table className="User_Table">
                  <thead>
                    <tr>
                      <th>SR NO</th>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Country</th>
                      <th>Image</th>
                      <th>Bio</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTestimonials.length > 0 ? (
                    currentTestimonials.map((testimonial, index) => (
                      <tr key={testimonial._id}>
                        <td>{indexOfLastTestimonial+index + 1}</td>
                        <td>{testimonial.name}</td>
                        <td>{testimonial.age}</td>
                        <td>{testimonial.country}</td>
                        <td>
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius:'5px' }}
                          />
                        </td>
                        <td>{testimonial.bio}</td>
                        <td className="EditDelteDiv">
                          <button onClick={() => handleEditTestimonial(testimonial._id)}>
                            <FiEdit />
                          </button>
                          <button
                            className="delete-btn"
                            onClick={() => handleDeleteTestimonial(testimonial._id)}
                          >
                            <MdDelete />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="7">Testimonial not found.</td>
                  </tr>
                )}
                  </tbody>
                </table>
              </div>

              {filteredTestimonials.length > 0 && (
                <div className="Tablepagination">
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <FaAngleDoubleLeft />
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => paginate(index + 1)}
                      className={currentPage === index + 1 ? 'active' : ''}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <FaAngleDoubleRight />
                  </button>
                </div>
              )}

            </>
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default Testimonials;
